import { ApiBase } from './ApiBase';
class OffersBundleApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getOfferBundle = (offerId) => {
            return this.get(`/offers-bundle/${offerId}`);
        };
        this.createOfferBundle = () => {
            return this.post(`/offers-bundle`);
        };
        this.updateOfferBundle = (offerId, body) => {
            return this.put(`/offers-bundle/${offerId}`, body);
        };
        this.replaceBundleImages = (offerId, body, replaceAll = false) => {
            return this.put(`/offers-bundle/${offerId}/images?replaceAll=${replaceAll}`, body);
        };
        this.addBundleImage = (offerId, body) => {
            return this.post(`/offers-bundle/${offerId}/images`, body);
        };
        this.getOffersPicker = (offerId, params) => {
            return this.get(`/offers-bundle/${offerId}/offers/picker`, params);
        };
        this.uploadBundleImage = (file) => {
            return this.post('/offers-bundle/images/upload', file);
        };
        this.calculateBundlePricing = (offerId, body) => {
            return this.post(`/offers-bundle/${offerId}/pricing-calculation`, body);
        };
        this.generateBundleImage = (offerId, body) => {
            return this.post(`/offers-bundle/${offerId}/images/generate`, body);
        };
        this.archiveOfferBundle = (offerId) => {
            return this.delete(`/offers-bundle/${offerId}`);
        };
    }
}
export const OffersBundleApiClient = new OffersBundleApiClientModel();
